import { PieceCatalog } from '@/features/piece-catalog/components/piece-catalog';

import { adminCatalogPiecePath } from './catalog-paths';

const AdminCatalogPage = () => (
  <PieceCatalog detailPath={adminCatalogPiecePath} />
);

export default AdminCatalogPage;
